import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import CrossPlatformHero from '../layouts/CrossPlatform/CrossPlatformHero'
import CrossPlatformBenefits from '../layouts/CrossPlatform/CrossPlatformBenefits'
import FinalCTA from '../layouts/FinalCTA'

const CrossPlatform = () => {
    return (
        <>
            <Header />
            <CrossPlatformHero />
            <CrossPlatformBenefits />
            <FinalCTA />
            <Footer />
        </>
    )
}

export default CrossPlatform 